import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import store from '@/store';
import {UserModel} from "@/share";
import {ServiceFactory} from "@/services";

const AuthService = ServiceFactory.get('auth')

const MUTATIONS_NAME = {
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  RESET_CURRENT_USER: 'RESET_CURRENT_USER',
  SET_CURRENT_BABY: 'SET_CURRENT_BABY'
};

@Module({
  dynamic: true,
  namespaced: true,
  name: 'user',
  store
})
export class User extends VuexModule {
  public isUserLoggedIn = false;
  public user: UserModel = new UserModel({});
  public babyId: string | number = ''

  get currentUser(): UserModel {
    return this.user;
  }

  get currentBaby(): string | number {
    return this.babyId;
  }

  @Mutation
  public [MUTATIONS_NAME.SET_CURRENT_USER](data: UserModel): void {
    this.user = data;
    this.isUserLoggedIn = true;
  }

  @Mutation
  public [MUTATIONS_NAME.RESET_CURRENT_USER](): void {
    this.user = {};
  }

  @Mutation
  public [MUTATIONS_NAME.SET_CURRENT_BABY](babyId: string | number): void {
    this.babyId = babyId;
  }

  @Action({commit: MUTATIONS_NAME.SET_CURRENT_USER})
  public async getCurrentUser(): Promise<void> {
    const res: any = await AuthService.getCurrentUser().catch(() => ({}));
    return res.data.data || {};
  }

  @Action({commit: MUTATIONS_NAME.SET_CURRENT_BABY})
  public async setCurrentBaby(babyId: string | number) {
    return babyId;
  }
}

export default getModule(User);
